import {Component, OnInit, ViewChild} from '@angular/core';
import {InformType} from '../../../global/util/enum/InformType';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DocumentService} from '../../../user/service/document.service';
import {Constant} from '../../../global/util/Constant';
import HttpStatusCode from '../../../global/util/HttpStatusCode';
import {ApplicationService} from '../../../user/service/application.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../user/service/auth/auth.service';
import {Dialog} from '../../../global/util/Dialog';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {Document} from '../../../user/model/Document';
import {Person} from '../../../user/model/Person';
import {PersonService} from '../../../user/service/person.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DomSanitizer} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-review-document',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.css']
})
export class ReviewComponent implements OnInit {
  public loading: boolean;
  private hashIdentifier;
  public document: Document;
  public documents: Document [] = [];
  public reviewForm: FormGroup;
  public urlStream;
  public wrongRequestPerson = true;
  public wrongRequestDocument = true;
  public personId;
  public person: Person;
  public resourceList: any[] = [];
  public hasMultipleAttachments;
  public title = 'TITLE.DOCUMENT-REVIEW';
  private reviewInfos: any[];
  public reloadingPdf = false;
  public progressUpdate = 0;
  public messageErrorRequest = '';
  public reviewCompleted = false;
  public errorMessage = false;
  @ViewChild('pdfViewer') pdfViewer;
  public showErrorMessage = false;
  public showSuccessMessage = false;

  constructor(private activatedRoute: ActivatedRoute,
              private sanitizer: DomSanitizer,
              private modalService: NgbModal,
              private formBuilder: FormBuilder,
              private personService: PersonService,
              private documentService: DocumentService,
              private applicationService: ApplicationService,
              private router: Router,
              private authenticationService: AuthService,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
    this.createForm();
    this.receiveParams();
  }

  public receiveParams() {
    this.activatedRoute.params.subscribe(params => {
      this.hashIdentifier = params.hashIdentifier;
      this.personId = +params.personId;
    });
  }


  ngOnInit() {
    this.loadPersonData(this.personId);
  }

  private loadPersonData(personId: number) {
    this.loading = true;
    const urlPerson = Constant.ROOT_API_V1.concat('/public/documents/')
      .concat(this.hashIdentifier)
      .concat('/people/').concat(String(personId));
    this.personService.get(urlPerson).subscribe((next: Person) => {
      this.loading = false;
      this.person = next;
      this.wrongRequestPerson = false;
      this.loadDocumentData(this.hashIdentifier);
    }, error => {
      this.loading = false;
      this.wrongRequestPerson = true;
      this.goBack();
      if (error.status) {
        if (HttpStatusCode.NOT_FOUND === error.status || HttpStatusCode.REQUEST_TIMEOUT === error.status) {
          this.messageErrorRequest = error.error.message;
        } else {
          this.messageErrorRequest = this.translate.instant('TITLE.DOCUMENT-REVIEW');
        }
      }
    });
  }

  private loadDocumentData(hashIdentifier: string) {
    this.loading = true;
    const urlDocument = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/hashIdentifier/', hashIdentifier, '/documents');
    this.personService.get(urlDocument).subscribe((next: Document) => {
      this.loading = false;
      this.documents.push(next);
      this.document = this.documents[0];
      this.resourceList = this.document._more.resources;
      this.hasMultipleAttachments = this.document._more.resources.length > 1;
      this.urlStream = this.document._more.resources[0].url;
      this.wrongRequestDocument = false;
      this.createEntities();
      this.loadData();
      // TODO AGREGAR
    }, error => {
      this.loading = false;
      this.wrongRequestDocument = true;
      this.messageErrorRequest = error.error.message;
    });
  }

  private loadData() {
    this.hasMultipleAttachments = this.document._more.resources.length > 1;
    this.reloadResourceList();
    const interval = setInterval(() => {
      if (!this.authenticationService.isAuthenticated()) {
        clearInterval(interval);
      }
    }, 300);
  }

  private createForm() {
    this.reviewForm = this.formBuilder.group(
      {
        observed: [''],
        cancelled: [''],
        comment: [''],
        attach: [false],
        file: [null],
        filename: ['']
      });
  }

  private applyValidators() {
    const reviewInfo = this.getReviewInfoBy(this.document);
    const control = this.reviewForm.get('comment');
    if (reviewInfo.observed || reviewInfo.cancelled) {
      control.setValidators(Validators.required);
      control.updateValueAndValidity();
    } else if (!reviewInfo.observed && !reviewInfo.cancelled) {
      control.clearValidators();
      control.updateValueAndValidity();
    }
  }

  public changeObserved(event) {
    const reviewInfo: ReviewInfo = this.getReviewInfoBy(this.document);
    if (event.target.checked) {
      reviewInfo.observed = true;
      const control = this.reviewForm.get('cancelled');
      const control2 = this.reviewForm.get('file');
      control.setValue(false);
      if (reviewInfo.cancelled) {
        reviewInfo.cancelled = false;
      }
      control2.clearValidators();
      control2.reset();
      control2.updateValueAndValidity();
      this.reviewForm.get('filename').setValue('');
    } else {
      reviewInfo.observed = false;
    }
    this.applyValidators();
  }

  public changeCancelled(event) {
    const reviewInfo: ReviewInfo = this.getReviewInfoBy(this.document);
    if (event.target.checked) {
      reviewInfo.cancelled = true;
      const control = this.reviewForm.get('attach');
      const control2 = this.reviewForm.get('file');
      control.setValue(false);
      if (reviewInfo.observed) {
        reviewInfo.observed = false;
      }
      control2.clearValidators();
      control2.reset();
      control2.updateValueAndValidity();
      this.reviewForm.get('filename').setValue('');
    } else {
      reviewInfo.cancelled = false;
    }
    this.applyValidators();
  }

  public changeAttach(event) {
    const control = this.reviewForm.get('attach');
    const control2 = this.reviewForm.get('file');
    if (event.target.checked) {
      control.setValue(true);
      control2.setValidators(Validators.required);
      control2.reset();
      control2.updateValueAndValidity();
    } else {
      control.setValue(false);
      control2.clearValidators();
      control2.reset();
      control2.updateValueAndValidity();
      this.reviewForm.get('filename').setValue('');
    }
  }

  private buildUrlSource() {
    this.urlStream = this.document._more.resources[0].url;
  }

  public isInvalidControl(ctrlName: string) {
    return this.reviewForm.get(ctrlName).invalid && this.reviewForm.get(ctrlName).touched;
  }

  public save(): void {
    if (this.reviewForm.invalid) {
      Object.values(this.reviewForm.controls).forEach(control => {
        control.markAsTouched();
      });
      return;
    }
    const reviewInfo = this.reviewInfos.find(value =>
      (value.observed && (value.comment === undefined || value.comment === '')) ||
      (value.cancelled && (value.comment === undefined || value.comment === ''))
    );
    if (reviewInfo) {
      const document = this.documents.find(value => reviewInfo.documentId === value.id);
      this.showErrorMessage = true;
      this.errorMessage = this.translate.instant('MESSAGE.THE-DOCUMENT-REQUIRES-THE-ENTRY-OF-COMMENTS-OBSERVATIONS'), String(document.subject);
      return;
    }
    this.loading = true;
    this.reviewOne2One();
  }

  private reviewOne2One() {
    const reviewInfo: ReviewInfo = this.getReviewInfoBy(this.document);
    let url = Constant.ROOT_API_V1.concat('/public')
      .concat('/documents/')
      .concat(String(this.document.id))
      .concat('/')
      .concat(this.document.hashIdentifier)
      .concat('/people/')
      .concat(String(this.personId));
    if (this.reviewForm.value.file) {
      url = url.concat('/review?uuid=');
    } else {
      url = url.concat('/review2?uuid=');
    }
    url = url.concat(String(this.document._more.uuid));
    const formData = new FormData();
    formData.append('observed', String(reviewInfo.observed ? 1 : 0));
    formData.append('cancelled', String(reviewInfo.cancelled ? 1 : 0));
    formData.append('comment', this.reviewForm.value.comment);
    if (this.reviewForm.value.file) {
      formData.append('file', this.reviewForm.value.file);
    }
    this.documentService.reviewOne2One(url, formData).subscribe((event: HttpEvent<any>) => {
      switch (event.type) {
        case HttpEventType.Sent:
          // TODO When request has been made
          break;
        case HttpEventType.ResponseHeader:
          // TODO When response header has been received
          break;
        case HttpEventType.UploadProgress:
          this.progressUpdate = Math.round(event.loaded / event.total * 100);
          break;
        case HttpEventType.Response:
          if (reviewInfo.cancelled || reviewInfo.observed) {
            this.showSuccessMessage = true;
            this.errorMessage = reviewInfo.observed ? this.translate.instant('MESSAGE.DOCUMENT-OBSERVED-SUCCESSFULLY') : this.translate.instant('MESSAGE.DOCUMENT-CANCELLED-SUCCESSFULLY');
          } else {
            this.navigateDocumentReviewed();
          }
          this.loading = false;
          this.reviewCompleted = true;
          break;
      }
    }, error => {
      this.progressUpdate = 0;
      this.loading = false;
      this.processError(error);
    });
  }


  public setUrlDoc(resource: any) {
    this.urlStream = resource.url;
    this.reloadPdfViewer();
  }

  private reloadPdfViewer(): void {
    this.reloadingPdf = true;
    const interval = setTimeout(() => {
      this.reloadingPdf = false;
    }, 300);
  }

  private processError(error: any) {
    this.showErrorMessage = true;
    const status = error.status;
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        this.errorMessage = error.error.message;
      } else if (HttpStatusCode.FORBIDDEN === status) {
        this.errorMessage = this.translate.instant('MESSAGE.SESSION-EXPIRED');
        this.logout();
      } else {
        this.errorMessage = error.error.message;
      }
    } else {
      this.errorMessage = error.error.message;
    }
  }

  private logout() {
    this.applicationService.setUserLoggedIn(false);
    this.router.navigate(['login']);
  }

  public reloadResourceList() {
    this.resourceList = this.document._more.resources;
    this.setUrlDoc(this.resourceList[0]);
    this.buildUrlSource();
    this.applyValidators();
  }

  private createEntities() {
    this.reviewInfos = this.documents.map(value => {
      const reviewInfo: ReviewInfo = {
        documentId: value.id,
        hashIdentifier: value.hashIdentifier,
        observed: false,
        cancelled: false,
        comment: ''
      };
      return reviewInfo;
    });
  }

  private getReviewInfoBy(document: any) {
    return this.reviewInfos.find(value => document.id === value.documentId);
  }

  public keyupComment(event) {
    if (event.target) {
      const reviewInfo: ReviewInfo = this.getReviewInfoBy(this.document);
      reviewInfo.comment = event.target.value;
    }
  }

  private goBack() {
    this.router.navigate(['document/' + this.hashIdentifier + '/people/' + this.personId + '/review/']).then();
  }

  private navigateDocumentReviewed() {
    this.router.navigate(['document/' + this.hashIdentifier + '/people/' + this.personId + '/document-signed/'], {
      state: {
        document: this.document,
        person: this.person
      }
    }).then();
  }

  public getObservedCheckedBy(document: any): boolean {
    const reviewInfo: ReviewInfo = this.getReviewInfoBy(document);
    return reviewInfo.observed;
  }

  public getCancelledCheckedBy(document: any): boolean {
    const reviewInfo: ReviewInfo = this.getReviewInfoBy(document);
    return reviewInfo.cancelled;
  }

  public getCommentBy(document: any): string {
    const reviewInfo: ReviewInfo = this.getReviewInfoBy(document);
    return reviewInfo.comment;
  }

  public changeStatus(event) {
    const fileSelected = (event.target as HTMLInputElement).files[0];
    if (!fileSelected.name.endsWith('.pdf')) {
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.DOCUMENT-REVIEW'), this.translate.instant('MESSAGE.SELECTED-NOT-ALLOWED-FILE'));
      return;
    }
    this.reviewForm.patchValue({
      file: fileSelected,
      filename: fileSelected.name
    });
    this.reviewForm.get('file').updateValueAndValidity();
  }

  get attachSelected(): boolean {
    return this.reviewForm.get('attach').value && this.hasUniqueAttach;
  }

  get hasUniqueAttach(): boolean {
    return this.resourceList.length === 1;
  }

  get cancelChecked(): boolean {
    return this.reviewForm.get('cancelled').value;
  }

  get observedChecked(): boolean {
    if (!this.cancelChecked) {
      return false;
    }
    return this.reviewForm.get('observed').value;
  }

  get closeStamping(): boolean {
    if (!this.hasUniqueAttach) {
      return true;
    }
    return this.document.closedStamping;
  }
}

class ReviewInfo {
  documentId: number;
  hashIdentifier: string;
  observed: boolean;
  cancelled: boolean;
  comment: string;
}

